import React from 'react';

import AddCommentActivities from 'ui/AddCommentActivities';

import { useStore } from 'utils/hooks/store';
import DeviceActivitiesStore from 'stores/DeviceDetails/DeviceActivities';

const DeviceActivitiesFooter: React.FunctionComponent = () => {
  const { deviceDetails } = useStore();
  const activities = deviceDetails.activities as DeviceActivitiesStore;
  return (
    <AddCommentActivities
      aria-label="device-activities-input"
      placeholder="Post an update"
      uploadFile={activities.uploadFile}
      sendMessage={activities.addMessage}
    />
  );
};

export default DeviceActivitiesFooter;
